export default "__VITE_ASSET__b_5xdxeB__"